<mat-form-field
  appearance="fill"
  class="fortress-search-form-field"
  [class.menu-opened]="auto.isOpen">
  <div
    matPrefix
    class="search-icon-container">
    @if (searchResultsResource.isLoading()) {
      <mat-spinner
        class="spinner"
        [diameter]="44"></mat-spinner>
    }
    <mat-icon
      class="search-icon"
      svgIcon="magnify"></mat-icon>
  </div>
  <input
    #input="matInput"
    matInput
    [formControl]="searchInput"
    placeholder="Search roles, permissions or users"
    [matAutocomplete]="auto" />
  @if (input.value) {
    <button
      mat-icon-button
      matSuffix
      class="clear-btn"
      type="button"
      matTooltip="Clear"
      (click)="reset()"
      data-cy="searchbar-clear-btn">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  }
</mat-form-field>

@let noResults = searchResultsTop5().length === 0;
<mat-autocomplete
  #auto="matAutocomplete"
  class="search-results-autocomplete"
  (optionSelected)="navigateToResult($event)"
  [displayWith]="selectedResultDisplayFn"
  [hideSingleSelectionIndicator]="true"
  [autoActiveFirstOption]="noResults">
  @if (searchResultsResource.hasValue() && !searchResultsResource.isLoading()) {
    @if (searchErrors().length > 0) {
      <mat-option
        class="custom-option"
        [value]="input.value"
        (click)="viewErrorDetails()">
        <div class="search-error">
          <mat-icon svgIcon="alert-circle-outline"></mat-icon>
          <span>Some results failed to load. Click to view details</span>
        </div>
      </mat-option>
    } @else if (noResults) {
      <mat-option
        class="custom-option readonly-option"
        [value]="input.value"
        >No results found</mat-option
      >
    }
    @for (result of searchResultsTop5(); track result) {
      <mat-option
        class="result-option"
        [value]="result">
        <div class="option-content">
          <div class="label-container">
            <span>{{ result.value }}</span>
            @if (result.description) {
              <span class="description">{{ result.description }}</span>
            }
          </div>
          <app-fortress-type-label
            class="option-type"
            [type]="result.type"></app-fortress-type-label>
        </div>
      </mat-option>
    }
  }
</mat-autocomplete>
